export enum GenderList {
  Male = "Male",
  Female = "Female",
}
